export default {
  ja:[
    "+ 新規作成",
    "それは何の作品のキャラクターですか？",
    "キャラクター名",
    "作品名",
    "作品名を選択または入力したらcreateボタンを押してね",
    "新しく",
    "を作成する",
    {
      api: {
        character: "キャラクター",
        maker: "メーカー",
        title: "タイトル",
      },
    },
    "キャンセル",
    "作成",
    "登録するデータを入力してください"
  ],
  en: [
    "+ create new",
    "Which title is this character from?",
    "character name",
    "content title",
    "Enter or select title to create!",
    "create new",
    "data",
    {
      api: {
        character: "character",
        maker: "maker",
        title: "title",
      },
    },
    "Cancel",
    "Create",
    "Create new data"
  ]
}
